import React from "react";
import "./About.css";
import about from "../images/About.webp"

function About() {

  return (

    <>
    <section className="about-section">

      {/* Left Image */}

      <div className="about-image">

        <img
          src={about}
          alt="about-service"
        />

      </div>

      {/* Right Content */}

      <div className="about-content">

        <span>About Us</span>

        <h1>
          Trusted Multi Brand <br />
          Washing Machine <br />
          Service Center
        </h1>

        <p>
          Chennai Washcare is a professional washing machine service center
          providing fast and reliable doorstep repair services across Chennai.
          We repair all major brands including LG, Samsung, IFB, Bosch,
          Whirlpool and more.
        </p>

        <p>
          Our expert technicians use genuine spare parts and advanced tools
          to ensure quality service with affordable pricing and customer
          satisfaction.
        </p>

        {/* About Features */}

        <div className="about-features">

          <div className="about-box">
            ✔ Same Day Service
          </div>

          <div className="about-box">
            ✔ Genuine Spare Parts
          </div>

          <div className="about-box">
            ✔ Expert Technicians
          </div>

          <div className="about-box">
            ✔ Affordable Pricing
          </div>

        </div>

        {/* Button */}

        <a
          href="tel:+919790066906"
          className="about-btn"
        >
          Call Now
        </a>

      </div>



    </section>
<section className="journey-section">

  {/* Left Side */}

  <div className="journey-left">

    <div className="year-circle">
      <h1>15+</h1>
      <span>Years</span>
    </div>

    <div className="journey-line"></div>

    <div className="journey-small-card">
      <h2>12K+</h2>
      <p>Happy Customers</p>
    </div>

  </div>

  {/* Right Side */}

  <div className="journey-content">

    <span>Our Journey</span>

    <h1>
      15+ Years Of Trusted <br />
      Washing Machine <br />
      Service Experience
    </h1>

    <p>
      Chennai Washcare has successfully repaired thousands of washing
      machines across Chennai with trusted technicians, genuine spare
      parts and quick doorstep service support.
    </p>

    {/* Timeline */}

    <div className="journey-timeline">

      <div className="timeline-item">

        <div className="timeline-dot"></div>

        <div>
          <h2>Professional Technicians</h2>
          <p>
            Skilled experts for all major washing machine brands.
          </p>
        </div>

      </div>

      <div className="timeline-item">

        <div className="timeline-dot"></div>

        <div>
          <h2>Doorstep Repair Service</h2>
          <p>
            Fast same day repair support across Chennai locations.
          </p>
        </div>

      </div>

      <div className="timeline-item">

        <div className="timeline-dot"></div>

        <div>
          <h2>Trusted Multi Brand Service</h2>
          <p>
            LG, Samsung, IFB, Bosch, Whirlpool and more.
          </p>
        </div>

      </div>

    </div>

  </div>

</section>

<section className="achievement-section">

  {/* Top Heading */}

  <div className="achievement-heading">

    <span>Why Customers Trust Us</span>

    <h1>
      Building Trust Through <br />
      Quality Service Since 15+ Years
    </h1>

  </div>

  {/* Achievement Cards */}

  <div className="achievement-container">

    {/* Card 1 */}

    <div className="achievement-card">

      <h2>15+</h2>

      <h3>Years Experience</h3>

      <p>
        Trusted washing machine repair service experience across Chennai.
      </p>

    </div>

    {/* Card 2 */}

    <div className="achievement-card">

      <h2>12K+</h2>

      <h3>Happy Customers</h3>

      <p>
        Thousands of satisfied customers with quality doorstep support.
      </p>

    </div>

    {/* Card 3 */}

    <div className="achievement-card">

      <h2>100%</h2>

      <h3>Genuine Spare Parts</h3>

      <p>
        High quality original spare parts for long lasting performance.
      </p>

    </div>

    {/* Card 4 */}

    <div className="achievement-card">

      <h2>24/7</h2>

      <h3>Customer Support</h3>

      <p>
        Quick customer assistance and fast service booking support.
      </p>

    </div>

  </div>

</section>
 
<section className="modern-review-section">

  {/* Heading */}

  <div className="modern-review-heading">

    <span>Customer Experience</span>

    <h1>
      Real Reviews From <br />
      Happy Customers
    </h1>

  </div>

  {/* Review Wrapper */}

  <div className="modern-review-wrapper">

    {/* Main Review Card */}

    <div className="main-review-card">

      <div className="quote-icon">
        "
      </div>

      <h2>
        Best Washing Machine Service In Chennai
      </h2>

      <p>
        Very professional and quick doorstep service. Technician fixed
        my LG washing machine within one visit and pricing was affordable.
      </p>

      <div className="review-user">

        <div className="review-avatar">
          A
        </div>

        <div>

          <h3>Arun Kumar</h3>

          <span>LG Washing Machine Service</span>

        </div>

      </div>

    </div>

    {/* Side Reviews */}

    <div className="side-review-container">

      {/* Card 1 */}

      <div className="side-review-card">

        <div className="mini-stars">
          ⭐⭐⭐⭐⭐
        </div>

        <p>
          Genuine spare parts and same day repair support.
        </p>

        <h4>Priya Sharma</h4>

      </div>

      {/* Card 2 */}

      <div className="side-review-card active-side-card">

        <div className="mini-stars">
          ⭐⭐⭐⭐⭐
        </div>

        <p>
          Best multi brand washing machine service center in Chennai.
        </p>

        <h4>Vignesh R</h4>

      </div>

      {/* Card 3 */}

      <div className="side-review-card">

        <div className="mini-stars">
          ⭐⭐⭐⭐⭐
        </div>

        <p>
          Technician arrived on time and solved the issue quickly.
        </p>

        <h4>Sneha Devi</h4>

      </div>

    </div>

  </div>

</section>





    </>

  );

}

export default About;